<script>
  import { onMount } from "svelte";
  import ListaHorarios from "./ListaHorarios.svelte"; // Reutiliza o mesmo modal
  import Conexoes from "../Classes/Conexoes";

  const conexao = new Conexoes();
  let showModal = false;

  // ------ SEO Constantes (FOCADO NO ONLINE) ------
  const SITE_URL = "https://www.allinemenezes.com.br/online";
  const SITE_TITLE =
    "Nutricionista Online - Dra. Alline Menezes | Atendimento para todo Brasil";
  const SITE_DESCRIPTION =
    "Consulta com nutricionista online pós-graduada em Nutrição Clínica e pós-graduanda em Nutrição Esportiva. Tenha seu plano alimentar personalizado, acesso ao App WebDiet e suporte via WhatsApp sem sair de casa.";
  const SITE_IMAGE_URL = `https://www.allinemenezes.com.br/img/5.webp`;

  // Diferenciais adaptados para a linguagem DIGITAL
  const diferenciais = [
    {
      icone: "fas fa-video",
      titulo: "Videoconferência Humanizada",
      descricao:
        "O atendimento é olho no olho, mesmo à distância. Conversamos por vídeo (WhatsApp, Meet ou Zoom) com a mesma atenção e profundidade da consulta presencial.",
    },
    {
      icone: "fab fa-whatsapp",
      titulo: "Suporte na Palma da Mão",
      descricao:
        "Dúvidas no mercado? Não sabe o que comer no restaurante? Estarei disponível no WhatsApp para te orientar em tempo real, onde quer que você esteja.",
    },
    {
      icone: "fas fa-mobile-alt",
      titulo: "Dieta no Aplicativo WebDiet",
      descricao:
        "Esqueça o papel. Seu plano alimentar, lista de compras, receitas e metas ficam disponíveis 24h no aplicativo exclusivo no seu celular.",
    },
    {
      icone: "fas fa-globe-americas",
      titulo: "Atendimento em Qualquer Lugar",
      descricao:
        "Mora em outra cidade, estado ou até fora do Brasil? Mantenha seu acompanhamento nutricional de qualidade sem barreiras geográficas.",
    },
    {
      icone: "fas fa-medal",
      titulo: "Pós-graudada em Nutrição Clínica",
      descricao:
        "Mesmo online, minha conduta é baseada em evidências científicas e especialização clínica, garantindo segurança e resultados reais para sua saúde.",
    },
    {
      icone: "fas fa-camera",
      titulo: "Avaliação por Fotos e Medidas",
      descricao:
        "Utilizo um protocolo validado de avaliação por fotos e medidas caseiras para acompanhar sua evolução estética e de emagrecimento com precisão.",
    },
  ];

  let faqData = [
    {
      id: 1,
      question: "A consulta online funciona mesmo?",
      answer:
        "Sim! Estudos mostram que a adesão ao tratamento online é altíssima pela praticidade. A anamnese (entrevista) é a mesma, e o acompanhamento próximo via WhatsApp garante que você não desanime.",
      isOpen: false,
    },
    {
      id: 2,
      question: "Como é feita a avaliação física à distância?",
      answer:
        "Utilizamos protocolos visuais (fotos comparativas padronizadas) e medidas de circunferência que você mesma(o) pode fazer com uma fita métrica simples, seguindo meu guia orientado.",
      isOpen: false,
    },
    {
      id: 3,
      question: "Recebo o plano alimentar na hora?",
      answer:
        "Discutimos as estratégias durante a consulta e o plano detalhado é liberado no Aplicativo em seguida, calculado especificamente para sua rotina e preferências.",
      isOpen: false,
    },
    {
      id: 4,
      question: "Quais formas de pagamento para o online?",
      answer:
        "Aceitamos Pix e Cartão de Crédito (via link de pagamento seguro), podendo parcelar os pacotes de acompanhamento.",
      isOpen: false,
    },
    {
      id: 5,
      question: "Tenho retorno na consulta online?",
      answer:
        "Trabalhamos com ciclos de acompanhamento. No plano avulso, você tem suporte de 15 dias. Nos planos trimestrais e semestrais, temos encontros mensais para ajustes constantes.",
      isOpen: false,
    },
  ];

  onMount(() => {
    RegitraAcesso();
    changeImage();
  });

  function AbrirModal() {
    showModal = true;
  }

  let currentImageIndex = 0;
  const images = ["./img/1.webp", "./img/2.webp", "./img/3.webp", "./img/4.webp"]; // Ajuste o caminho se necessário (ex: ../img/)

  function changeImage() {
      currentImageIndex = Math.floor(Math.random() * images.length);
  }

  async function RegitraAcesso() {
    console.log("Registrando acesso à página ONLINE");
  }

  // --- Schema.org JSON-LD para Telemedicina ---
  const physicianSchema = {
    "@context": "https://schema.org",
    "@type": "Physician",
    name: "Dra. Alline Menezes - Nutricionista Online",
    image: SITE_IMAGE_URL,
    "@id": SITE_URL,
    url: SITE_URL,
    telephone: "+5581996280325",
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      addressCountry: "BR", // Foco no país
      addressLocality: "Atendimento Nacional",
    },
    "availableService": {
        "@type": "Service",
        "name": "Consulta Nutricional Online",
        "serviceType": "Telemedicine",
        "areaServed": {
             "@type": "Country",
             "name": "Brasil"
        },
        "availableChannel": {
            "@type": "ServiceChannel",
            "serviceUrl": "https://wa.me/5581996280325",
            "servicePhone": "+5581996280325"
        }
    },
    sameAs: [
      "https://instagram.com/allinemenezes.nutri",
    ],
    description: SITE_DESCRIPTION,
  };
</script>

<style>
  /* --- REAPROVEITAMENTO DOS ESTILOS DO SITE PRINCIPAL --- */
  /* Cole aqui o mesmo CSS do seu site principal para manter a identidade visual. */
  /* Vou adicionar apenas as classes específicas ou modificações para o online abaixo */

  @font-face {
    font-family: "Century Gothic";
    src: url("../CenturyGothic.ttf") format("truetype"); /* Ajuste o caminho da fonte se mudar de pasta */
    font-weight: normal;
    font-style: normal;
  }

  /* ... (COLE AQUI TODO O CSS DO ARQUIVO ANTERIOR) ... */
  /* ... Mantenha tudo igual para garantir o visual ... */
  
  /* Adicionei este estilo extra para o passo a passo */
  .passo-a-passo {
      background-color: #fff;
      padding: 50px 20px;
      text-align: center;
  }
  .passo-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px;
      margin-top: 30px;
  }
  .passo-item {
      flex: 1 1 200px;
      max-width: 250px;
      text-align: center;
  }
  .passo-numero {
      background-color: #a1b57d;
      color: white;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      margin: 0 auto 15px;
      font-size: 20px;
  }
  
  /* Ajustes de responsividade e layout (Copiados do original) */
  .contatos-container { display: flex; justify-content: center; align-items: center; text-align: center; padding: 40px 0; }
  .contato-item { display: flex; align-items: center; margin-bottom: 20px; font-size: 16px; }
  .contato-item img { width: 24px; height: 24px; margin-right: 10px; }
  .barra { display: block; width: 100%; height: auto; z-index: 5; margin-top: 20px; margin-bottom: 20px; }
  .fale-conosco { background-color: white; padding: 40px 20px; text-align: center; border-top: 2px solid #d4af37; }
  .fale-conosco h2 { font-size: 28px; margin-bottom: 30px; font-family: "Century Gothic", sans-serif; }
  .contatos { text-align: left; display: flex; flex-direction: column; gap: 15px; }
  .contatos p { font-size: 18px; margin: 10px 0; font-family: "Century Gothic", sans-serif; }
  .contatos a { color: #a1b57d; text-decoration: none; font-weight: bold; }
  .contatos a:hover { text-decoration: underline; }
  .whatsapp-float { position: fixed; bottom: 20px; right: 20px; width: 60px; height: 60px; background-color: #1bd741; border-radius: 50%; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); display: flex; justify-content: center; align-items: center; z-index: 1000; animation: bounce 2s infinite; }
  .whatsapp-float img { width: 35px; height: 35px; }
  .whatsapp-float:hover { transform: scale(1.1); transition: 0.3s ease; }
  @keyframes bounce { 0%, 20%, 50%, 80%, 100% { transform: translateY(0); } 40% { transform: translateY(-10px); } 60% { transform: translateY(-5px); } }
  .centralizado { text-align: center; }
  .container { font-family: "Century Gothic", sans-serif; position: relative; }
  .marca { display: block; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 20%; max-width: 150px; height: auto; opacity: 0.08; z-index: 0; }
  .foto { display: block; width: 100%; max-width: 300px; height: auto; order: 2; margin-left: 0; margin-top: 20px; }
  @media (min-width: 768px) { .foto { margin-left: 20px; margin-top: 0; } .main-section { flex-wrap: nowrap; } }
  .motivational-quote p { font-size: 18px; font-style: italic; color: #666; margin-top: 20px; text-align: center; margin: 40px 20px; }
  .rodape { background-color: #ffffff; padding: 20px 0; color: white; position: relative; margin-top: 4px; }
  .header { display: flex; justify-content: space-between; align-items: center; background-color: rgb(255, 255, 254); padding: 10px 20px; color: black; flex-wrap: wrap; position: relative; }
  .header::before { content: ""; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: url("./img/maca.png") no-repeat right center; background-size: contain; opacity: 0.05; z-index: 0; }
  .logo { display: flex; align-items: center; text-align: center; margin: auto; position: relative; z-index: 1; }
  .logo-icone { width: 250px; max-width: 100%; margin-right: 10px; }
  nav ul { list-style: none; display: flex; gap: 15px; margin: 0; padding: 0; flex-wrap: wrap; justify-content: center; }
  nav a { text-decoration: none; color: rgb(0, 0, 0); font-size: 15px; padding: 5px 8px; }
  nav a:hover { text-decoration: underline; color: #a1b57d; }
  .fundo-nav { background-color: #ffffff; padding: 10px 0; color: rgb(0, 0, 0); position: relative; z-index: 1; }
  .main-section { align-items: center; background-color: #ffffff; padding: 30px 20px; color: rgb(99, 99, 99); position: relative; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); flex-wrap: wrap; }
  .main-section h1 { font-size: 26px; color: #333; margin-bottom: 15px; line-height: 1.3; }
  @media (min-width: 768px) { .main-section h1 { font-size: 32px; } }
  .about { max-width: 600px; margin-left: 0; position: relative; z-index: 1; }
  @media (min-width: 768px) { .about { margin-left: 40px; } }
  .about p { font-size: 17px; line-height: 1.6; margin-bottom: 25px; }
  .about button { background-color: #a1b57d; color: #ffffff; border: none; padding: 12px 22px; font-size: 17px; cursor: pointer; border-radius: 5px; transition: background-color 0.3s ease; }
  .about button:hover { background-color: #8aa864; }
  .ajuda { background-color: #f9f9f9; padding: 40px 20px; text-align: center; }
  .ajuda h2 { font-size: 28px; margin-bottom: 30px; font-family: "Century Gothic", sans-serif; color: #333; }
  .cards-container { display: flex; flex-wrap: wrap; justify-content: center; gap: 20px; max-width: 1200px; margin: 0 auto; }
  .card { flex: 1 1 calc(33.333% - 20px); min-width: 280px; max-width: 320px; background-color: #fff; border-radius: 10px; padding: 25px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08); text-align: center; transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease; margin: 10px; display: flex; flex-direction: column; align-items: center; }
  @media (max-width: 992px) { .card { flex: 1 1 calc(50% - 20px); } }
  @media (max-width: 600px) { .card { flex: 1 1 100%; max-width: none; } }
  .card:hover { transform: translateY(-7px); box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12); }
  .card h3 { font-size: 19px; margin-top: 10px; margin-bottom: 15px; color: #333; font-family: "Century Gothic", sans-serif; }
  .card p { font-size: 15px; line-height: 1.6; color: #555; font-family: "Century Gothic", sans-serif; }
  .card-icon { font-size: 2.2rem; margin-bottom: 0.5rem; }
  .card-alimentacao { border-top: 4px solid #8ac926; }
  .card-intestino { border-top: 4px solid #ff7f11; }
  .card-emagrecimento { border-top: 4px solid #1982c4; }
  .card-metabolico { border-top: 4px solid #6a4c93; }
  .card-avaliacao { border-top: 4px solid #ffca3a; }
  .card-massa { border-top: 4px solid #8ac926; }
  .btn-agendar-cards { background-color: #a1b57d; color: #fff; border: none; padding: 12px 24px; font-size: 18px; cursor: pointer; border-radius: 8px; transition: background-color 0.3s ease; margin-top: 30px; font-family: "Century Gothic", sans-serif; display: block; margin-left: auto; margin-right: auto; }
  .btn-agendar-cards:hover { background-color: #8aa864; }
  .detalhes-atendimento { background-color: #f9f9f9; padding: 40px 20px; text-align: center; }
  .detalhes-atendimento h2 { font-size: 28px; margin-bottom: 30px; font-family: "Century Gothic", sans-serif; color: #333; }
  .detalhes-container { display: flex; flex-wrap: wrap; justify-content: center; gap: 20px; max-width: 1200px; margin: 0 auto; }
  .detalhe-item { flex: 1 1 calc(33.333% - 20px); min-width: 280px; max-width: 350px; background-color: #fff; border-radius: 10px; padding: 25px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08); text-align: center; margin: 10px; transition: transform 0.3s ease, box-shadow 0.3s ease; }
  @media (max-width: 992px) { .detalhe-item { flex: 1 1 calc(50% - 20px); } }
  @media (max-width: 600px) { .detalhe-item { flex: 1 1 100%; max-width: none; } }
  .detalhe-item:hover { transform: translateY(-7px); box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12); }
  .detalhe-icone { font-size: 2.2rem; margin-bottom: 0.5rem; color: #a1b57d; }
  .detalhe-item h3 { font-size: 19px; margin-top: 10px; margin-bottom: 15px; color: #333; font-family: "Century Gothic", sans-serif; }
  .detalhe-item p { font-size: 15px; line-height: 1.6; color: #555; font-family: "Century Gothic", sans-serif; }
  
  /* ESTILOS DA SEÇÃO DE PLANOS (COPIADO DO ANTERIOR) */
  .planos { background-color: #fff; padding: 50px 20px; text-align: center; }
  .planos h2 { font-size: 30px; color: #a1b57d; font-family: "Century Gothic", sans-serif; margin-bottom: 15px; }
  .card-plano { background: #fff; border: 1px solid #eee; padding: 30px 20px; border-radius: 12px; position: relative; display: flex; flex-direction: column; justify-content: space-between; }
  .card-plano.destaque { border: 2px solid #d4af37; background-color: #fffcf5; transform: scale(1.02); }
  .card-plano h3 { color: #a1b57d; font-size: 24px; margin-bottom: 5px; }
  .subtitulo-plano { display: block; font-size: 14px; text-transform: uppercase; color: #888; margin-bottom: 15px; letter-spacing: 1px; font-weight: bold; }
  .lista-beneficios { list-style: none; padding: 0; margin: 20px 0; text-align: left; width: 100%; }
  .lista-beneficios li { margin-bottom: 10px; color: #555; font-size: 15px; }
  .lista-beneficios i { color: #a1b57d; margin-right: 8px; }
  .badge-destaque { position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background-color: #d4af37; color: white; padding: 5px 15px; border-radius: 20px; font-size: 12px; font-weight: bold; text-transform: uppercase; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
  .btn-plano { display: inline-block; padding: 10px 20px; border: 1px solid #a1b57d; border-radius: 25px; color: #a1b57d; text-decoration: none; font-weight: bold; transition: all 0.3s; margin-top: 15px; }
  .btn-plano:hover { background-color: #a1b57d; color: white; text-decoration: none; }
  .btn-destaque { background-color: #a1b57d; color: white; }
  .btn-destaque:hover { background-color: #8aa864; border-color: #8aa864; }

  .faq { background-color: #fff; padding: 40px 20px; text-align: center; }
  .faq h2 { font-size: 28px; margin-bottom: 30px; font-family: "Century Gothic", sans-serif; color: #333; }
  .faq-container { max-width: 800px; margin: 0 auto; }
  .faq-item { margin-bottom: 15px; border-bottom: 1px solid #eee; text-align: left; }
  .faq-item:last-child { border-bottom: none; }
  .faq-question { background-color: transparent; border: none; padding: 15px 5px; width: 100%; text-align: left; font-size: 17px; cursor: pointer; display: flex; justify-content: space-between; align-items: center; font-family: "Century Gothic", sans-serif; color: #444; font-weight: 600; }
  .faq-question:hover { color: #a1b57d; }
  .faq-answer { padding: 0px 5px 15px 5px; overflow: hidden; text-align: left; }
  .faq-answer p { font-size: 15px; line-height: 1.7; color: #555; margin-bottom: 0; font-family: "Century Gothic", sans-serif; }
  .fa-chevron-down { transition: transform 0.3s ease; color: #a1b57d; }
  .faq-question i.rotate { transform: rotate(180deg); }
  .sobre-mim { background-color: #fdfdfd; padding: 40px 20px; }
  .sobre-mim-container { max-width: 1100px; margin: 0 auto; display: flex; flex-wrap: wrap; align-items: flex-start; gap: 30px; }
  .sobre-mim-foto { flex: 1 1 300px; max-width: 380px; display: flex; justify-content: center; }
  .sobre-mim-foto img { width: 100%; max-width: 350px; height: auto; border-radius: 10px; object-fit: cover; box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); }
  .sobre-mim-texto { flex: 2 1 550px; text-align: left; }
  .sobre-mim-texto h2 { font-size: 28px; margin-bottom: 10px; font-family: "Century Gothic", sans-serif; color: #333; }
  .sobre-mim-texto h3 { font-size: 22px; color: #a1b57d; margin-bottom: 5px; font-family: "Century Gothic", sans-serif; font-weight: bold; }
  .crn { font-size: 15px; font-style: italic; color: #777; margin-bottom: 15px; }
  .minha-historia p { margin-bottom: 15px; font-size: 16px; line-height: 1.7; color: #555; font-family: "Century Gothic", sans-serif; }
  @media (max-width: 768px) { .sobre-mim-container { flex-direction: column; align-items: center; } .sobre-mim-foto { max-width: 80%; margin-bottom: 20px; } .sobre-mim-texto h2, .sobre-mim-texto h3 { text-align: center; } .crn { text-align: center; } }
  .nota { font-size: 12px; color: #777; font-style: italic; }
  .por-que-escolher { background-color: #f9f9f9; padding: 40px 20px; text-align: center; }
  .por-que-escolher h2 { font-size: 30px; margin-bottom: 15px; font-family: "Century Gothic", sans-serif; color: #d4af37; }
  .intro { font-size: 17px; line-height: 1.6; color: #555; max-width: 800px; margin: 0 auto 30px; font-family: "Century Gothic", sans-serif; }
  .diferenciais-container { display: flex; flex-wrap: wrap; justify-content: center; gap: 30px; max-width: 1200px; margin: 0 auto; }
  .diferencial-item-destaque { border: 1px solid #d4af37; background-color: #fff; }
  .diferencial-item { flex: 1 1 calc(50% - 30px); min-width: 280px; max-width: 420px; background-color: #fff; border-radius: 10px; padding: 25px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08); text-align: center; transition: transform 0.3s ease, box-shadow 0.3s ease; margin: 10px; display: flex; flex-direction: column; align-items: center; }
  .diferencial-item:hover { transform: translateY(-7px); box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12); }
  .diferencial-icone { font-size: 2.5rem; margin-bottom: 1rem; color: #d4af37; }
  .diferencial-item h3 { font-size: 20px; margin-bottom: 15px; color: #333; font-family: "Century Gothic", sans-serif; }
  .diferencial-item p { font-size: 15px; line-height: 1.6; color: #555; font-family: "Century Gothic", sans-serif; text-align: left; flex-grow: 1; }
  .diferencial-item .nota { font-size: 11px; text-align: center; margin-top: 10px; width: 100%; }
  .btn-agendar { background-color: #a1b57d; color: #fff; border: none; padding: 12px 24px; font-size: 18px; cursor: pointer; border-radius: 8px; transition: background-color 0.3s ease; margin-top: 30px; font-family: "Century Gothic", sans-serif; display: block; margin-left: auto; margin-right: auto; }
  .btn-agendar:hover { background-color: #8aa864; }
  @media (max-width: 992px) { .diferencial-item { flex: 1 1 100%; max-width: 500px; } }
  @media (max-width: 768px) { .intro { font-size: 16px; } }
</style>

<svelte:head>
  <title>{SITE_TITLE}</title>
  <meta name="description" content={SITE_DESCRIPTION} />
  <meta
    name="keywords"
    content="nutricionista online, consulta nutricionista online, dieta online,
    nutricionista emagrecimento online, reeducação alimentar online, Alline Menezes nutricionista" />
  <link rel="canonical" href={SITE_URL} />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={SITE_URL} />
  <meta property="og:title" content={SITE_TITLE} />
  <meta property="og:description" content={SITE_DESCRIPTION} />
  <meta property="og:image" content={SITE_IMAGE_URL} />
  <meta property="og:locale" content="pt_BR" />
  <meta property="og:site_name" content="Alline Menezes Nutricionista Online" />
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
    integrity="sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA=="
    crossorigin="anonymous"
    referrerpolicy="no-referrer" />
  
</svelte:head>

<main class="container">
  <header
    class="header d-flex flex-column flex-md-row align-items-center
    justify-content-between">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="logo">
        <a href="https://www.allinemenezes.com.br">
            <img
            class="logo-icone"
            src="./img/logo2.png"
            alt="Logo Alline Menezes Nutricionista" />
        </a>
      </div>
    </div>
    <nav class="navbar fundo-nav w-100 mt-3 mt-md-0">
      <div class="d-none d-md-flex w-100 justify-content-center">
        <ul class="navbar-nav d-flex flex-row justify-content-center">
          <li class="nav-item mx-3">
            <a class="nav-link" href="https://www.allinemenezes.com.br">{'Ir para Site Principal'}</a>
          </li>
          <li class="nav-item mx-3">
            <a class="nav-link" href="#planos">{'Planos Online'}</a>
          </li>
          <li class="nav-item mx-3">
            <a class="nav-link" href="#" on:click={AbrirModal}>
              {'Agendar Agora'}
            </a>
          </li>
          <li class="nav-item mx-3">
            <a class="nav-link" href="#comoFunciona">
              {'Como Funciona o Online'}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>

  <section
    id="home"
    class="main-section d-flex flex-column flex-md-row align-items-center">
    <img
      src="./img/marca.png"
      alt="Marca d'água Alline Menezes Nutricionista"
      class="marca" />

    <div class="about text-center text-md-left">
      <h1>
        Nutricionista Online: Transforme sua Saúde de Onde Estiver
      </h1>
      <p>
        <strong>
          Sem trânsito, sem espera e com o suporte que você precisa.
        </strong>
        Tenha acesso a um acompanhamento nutricional de excelência, pós-graduada em Nutrição Clínica, sem sair do conforto da sua casa. Seu plano alimentar na palma da mão com o app WebDiet.
      </p>
      <button class="btn btn-primary" style="z-index:10" on:click={AbrirModal}>
        Quero agendar minha consulta online
      </button>
    </div>
    <img
      src={images[currentImageIndex]}
      alt="Alline Menezes, nutricionista online"
      class="foto foto-animada" />
  </section>

  <section id="comoFunciona" class="passo-a-passo">
      <h2>Como Funciona a Nutrição Online?</h2>
      <p>Um método prático e validado para te atender em qualquer lugar do mundo.</p>
      
      <div class="passo-container">
          <div class="passo-item">
              <div class="passo-numero">1</div>
              <h3>Agendamento</h3>
              <p>Você escolhe o melhor horário e realizamos a consulta via videochamada (WhatsApp/Meet).</p>
          </div>
          <div class="passo-item">
              <div class="passo-numero">2</div>
              <h3>Anamnese & Avaliação</h3>
              <p>Conversamos sobre sua rotina e utilizamos fotos/medidas simples para avaliar sua composição corporal.</p>
          </div>
          <div class="passo-item">
              <div class="passo-numero">3</div>
              <h3>Plano no App</h3>
              <p>Você recebe seu planejamento, lista de compras e receitas direto no aplicativo WebDiet.</p>
          </div>
          <div class="passo-item">
              <div class="passo-numero">4</div>
              <h3>Suporte Contínuo</h3>
              <p>Tire dúvidas direto comigo pelo WhatsApp durante todo o seu acompanhamento.</p>
          </div>
      </div>
  </section>

  <section class="ajuda">
    <h2>Especialidades do Atendimento</h2>
    <div class="cards-container">
      <div class="card card-emagrecimento">
        <i class="fas fa-weight-scale card-icon" />
        <h3>Emagrecimento Saudável</h3>
        <p>
          Perda de peso sustentável com estratégias que se adaptam à sua rotina, sem dietas restritivas extremas.
        </p>
      </div>
      <div class="card card-intestino">
        <i class="fas fa-heartbeat card-icon" />
        <h3>Saúde Intestinal</h3>
        <p>
          Tratamento de disbiose, constipação e gases através da alimentação, melhorando sua imunidade e bem-estar.
        </p>
      </div>
      <div class="card card-massa">
        <i class="fas fa-dumbbell card-icon" />
        <h3>Hipertrofia e Performance</h3>
        <p>
          Ajuste fino de macronutrientes para quem treina e busca ganho de massa muscular ou definição.
        </p>
      </div>
    </div>
  </section>

  <section class="planos" id="planos">
    <h2>Planos de Acompanhamento Online</h2>
    <p class="intro">
      Escolha o ciclo ideal para sua transformação digital.
    </p>

    <div class="cards-container">
      <div class="card card-plano">
        <h3>Start Online</h3>
        <span class="subtitulo-plano">Consulta Avulsa</span>
        <p>Para quem busca uma avaliação pontual e direcionamento.</p>
        <ul class="lista-beneficios">
           <li><i class="fas fa-check"></i> Videoconferência (1h)</li>
           <li><i class="fas fa-check"></i> Plano Alimentar no App</li>
           <li><i class="fas fa-check"></i> Suporte de 15 dias</li>
        </ul>
        <a href="https://wa.me/5581996280325?text=Olá! Vim do site online e gostaria de saber o valor da Consulta Avulsa." target="_blank" class="btn-plano">Consultar Valor</a>
      </div>

      <div class="card card-plano">
        <h3>Mudança de Hábito</h3>
        <span class="subtitulo-plano">Trimestral</span>
        <p>Acompanhamento de 3 meses para consolidar resultados.</p>
        <ul class="lista-beneficios">
           <li><i class="fas fa-check"></i> 3 Consultas Online</li>
           <li><i class="fas fa-check"></i> Ajustes mensais na dieta</li>
           <li><i class="fas fa-check"></i> Suporte contínuo</li>
        </ul>
        <a href="https://wa.me/5581996280325?text=Olá! Vim do site online e me interessei pelo Plano Trimestral." target="_blank" class="btn-plano">Ver Condições</a>
      </div>

      <div class="card card-plano destaque">
        <div class="badge-destaque">Recomendado</div>
        <h3>Estilo de Vida</h3>
        <span class="subtitulo-plano">Semestral</span>
        <p>A virada de chave definitiva na sua alimentação.</p>
        <ul class="lista-beneficios">
           <li><i class="fas fa-check"></i> 6 Consultas Online</li>
           <li><i class="fas fa-check"></i> Evolução por fotos</li>
           <li><i class="fas fa-check"></i> Melhor custo-benefício</li>
        </ul>
        <a href="https://wa.me/5581996280325?text=Olá! Vim do site online e quero saber sobre o Plano Semestral." target="_blank" class="btn-plano btn-destaque">Melhor Preço</a>
      </div>
    </div>
  </section>

  <section class="sobre-mim" id="Sobre_mim">
    <div class="sobre-mim-container">
      <div class="sobre-mim-foto">
        <img
          src="./img/5.webp"
          alt="Foto de Alline Menezes" />
      </div>
      <div class="sobre-mim-texto">
        <h2>
          Quem cuidará de você?
        </h2>
        <h3>Alline Menezes</h3>
        <p class="crn">Nutricionista CRN-6 47556/P</p>

        <div class="minha-historia">
          <p>
            Minha missão é levar nutrição de qualidade para onde você estiver. Sou pós-graduada em Nutrição Clínica e pós-graduanda em Nutrição Esportiva.
          </p>
          <p>
            Com a telemedicina, consegui expandir meu método de "Nutrição sem Terrorismo" para pacientes de todo o Brasil e até do exterior. Acredito que a distância física não impede um cuidado próximo e humano.
          </p>
          <p>
            Meu foco é te ajudar a emagrecer, ganhar massa ou tratar questões de saúde sem dietas malucas, usando a tecnologia do nosso aplicativo para facilitar sua rotina corrida.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="por-que-escolher">
    <h2>
      Por Que Escolher o Atendimento Online?
    </h2>
    <div class="diferenciais-container">
      {#each diferenciais as diferencial (diferencial.titulo)}
        <div class="diferencial-item diferencial-item-destaque">
          <i class={diferencial.icone + ' diferencial-icone'} />
          <h3>{diferencial.titulo}</h3>
          <p>{diferencial.descricao}</p>
        </div>
      {/each}
    </div>
    <button class="btn-agendar" on:click={() => (showModal = true)}>
      Quero começar minha mudança agora
    </button>
  </section>

  <img src="./img/barra.png" alt="Barra divisória" class="barra" />

  <section class="faq">
    <h2>Dúvidas sobre a Consulta Online</h2>
    <div class="faq-container">
      {#each faqData as item (item.id)}
        <div class="faq-item">
          <button
            class="faq-question"
            on:click={() => (item.isOpen = !item.isOpen)}>
            {item.question}
            <i class="fas fa-chevron-down" class:rotate={item.isOpen} />
          </button>
          {#if item.isOpen}
            <div class="faq-answer">
              <p>{item.answer}</p>
            </div>
          {/if}
        </div>
      {/each}
    </div>
  </section>

  <section class="fale-conosco text-center">
    <h2>
      Ficou com alguma dúvida?
    </h2>
    <div class="contatos-container">
      <div class="contatos">
        <div class="contato-item">
          <img src="img/zap.png" alt="WhatsApp" />
          <strong>WhatsApp:</strong>
          <a href="https://wa.me//5581996280325" target="_blank">
            (81) 9 9628-0325
          </a>
        </div>
        <div class="contato-item">
          <img src="img/instagram.png" alt="Instagram" />
          <strong>Instagram:</strong>
          <a href="https://instagram.com/allinemenezes.nutri" target="_blank">
            @allinemenezes.nutri
          </a>
        </div>
      </div>
    </div>
    <div class="whatsapp-float">
      <a
        href="https://wa.me/5581996280325?text=Olá! Vim do site online e gostaria de agendar."
        target="_blank">
        <img
          src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
          alt="WhatsApp Icon" />
      </a>
    </div>
  </section>
  <div class="nota" style="text-align: center; padding: 10px;">
      <p>Sede Administrativa: Campina Grande - PB | Atendimento Online para todo Brasil</p>
  </div>

</main>

<ListaHorarios ordem={1} filtroOnline={1} {showModal} on:close={() => (showModal = false)} />